import { render, staticRenderFns } from "./PodcastSlide.vue?vue&type=template&id=156ab98d&scoped=true"
import script from "./PodcastSlide.vue?vue&type=script&lang=js"
export * from "./PodcastSlide.vue?vue&type=script&lang=js"
import style0 from "./PodcastSlide.vue?vue&type=style&index=0&id=156ab98d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156ab98d",
  null
  
)

export default component.exports